import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_ONBOARDING';

const en = {
    onboarding_tabs_title: 'First Steps',
    onboarding_continue_title: 'Continue onboarding?',
    onboarding_continue_msg:
        'We haven’t finished customizing the system yet. \n Would you like to continue customizing?',
    onboarding_continue_action_primary: 'Go',

    welcome_title: 'Welcome to Priority',
    welcome_text:
        'Congratulations on your decision to take your business to the next level. \n In the next few steps, we’ll ask a few questions, and write down some details, in order to tailor the system to your specific needs.',
    welcome_skip_label: "Close and don't show again",
    skip_warning: "Are you sure you don't want to customize the system?",
    welcome_action_secondary: 'Later',
    welcome_action_primary: "Let's go",
    welcome_action_se: 'Skip and don’t show again',
    skip_btn_label_yes: 'Yes, exit',
    skip_btn_label_no: 'No, continue customizing',

    general_info_tab_title: 'Workspace',
    general_info_tab_subtitle:
        'We will now customize the system to your business workflows.  Let’s go over the following topics, and according to your answers, we will prepare your workspace.',
    general_info_tab_list_title:
        'As your business grows, you may want to expand or change your use of Priority. Don’t worry, you can make changes to your workspace at any time.',

    general_info_tab_start: "Let's go",
    general_info_tab_success_title: 'Your workspace is ready!',
    general_info_tab_success_text:
        'In the summary you can see a report with your updated details, in addition to tips for starting your work.',
    general_info_tab_success_btn: 'Next',

    workspace_dialog_title: 'We will now start to customize your workspace',
    workspace_dialog_btn_ok: 'OK',
    workspace_dialog_btn_back: 'Go back',

    company_tab_title: 'Company details',
    company_tab_subtitle:
        'Let’s set up your company details. \n This information will appear on documents and printouts.',
    company_name_label: 'Company Name',
    company_name_placeholder: "Enter your company's name here...",
    tax_id_label: 'Federal Tax ID',
    tax_id_placeholder: 'Type Federal Tax ID...',
    company_number: 'Company Number',
    company_number_placeholder: 'Enter the number here...',
    logo_label: 'Logo',
    logo_placeholder: 'Add your logo file here',
    street_label: 'Street Address',
    street_placeholder: 'Enter the street and house number...',
    city_label: 'City',
    city_placeholder: 'Enter the city name here...',
    state_label: 'State',
    state_placeholder: 'Choose the state here...',
    country_label: 'Country',
    country_placeholder: 'Choose the country here...',
    zipcode_label: 'Zip Code',
    zipcode_placeholder: 'Enter the zip code here...',
    email_label: 'Email',
    email_placeholder: 'your@email.com',
    website_label: 'Website',
    website_placeholder: 'https://www.yourwebsite.com',
    phone_label: 'Phone No.',
    phone_placeholder: '051-234-5678',
    company_tab_submit: 'Save',
    company_readonly_subtitle: 'We set up your company details as recorded here:',
    company_readonly_footer_text: 'You can change one or more of the details here:',
    company_readonly_footer_btn: 'Company Data form',

    bank_acc_tab_title: 'Bank account',
    bank_acc_tab_subtitle:
        'For keeping your books balansed, here you can find all your default charts of accounts, or add new ones. \n You can find more options on',
    bank_code_name_label: '"Bank"',
    bank_code_name_placeholder: 'Choose from the list...',
    branch_number_label: 'Bank Branch',
    branch_number_placeholder: 'Enter the branch number...',
    account_number_label: 'Account Number',
    account_number_placeholder: 'Enter the account number...',
    account_name_label: 'Account name',
    account_name_placeholder: '"Add a short description..."',
    account_currency_label: 'Currency',
    account_currency_placeholder: '"Choose from the list..."',
    gl_account_label: 'GL Account',
    gl_account_placeholder: 'Select GL account here',
    send_invoices_label: 'Would you like to use digitally signed invoices?',
    send_invoices_desc: 'This signature will appear on invoices, receipts, etc.',
    send_invoices_help: '',
    send_invoices_yes: 'Yes',
    send_invoices_no: 'No',
    bank_tab_submit: 'Save',
    bank_acc_tab_success: 'Your bank account details were saved',
    bank_acc_readonly_subtitle: 'Your bank account details have been saved here:',
    bank_account_changes_msg:
        'You can change and add details to this account, or record more bank accounts, here:',
    bank_account_multi_accounts_msg: 'You can view all your bank account here:',
    bank_acc_btn: 'Bank Accounts form',

    summary_tab_title: 'Summary',
    summary_tab_subtext:
        'The details you recorded are updated in Priority, and you can see them in the summary report, too.',
    summary_tab_btn: 'Done',
    summary_tab_message: 'Want to see what you did?',
    summary_list_title: "You haven't completed some details:",
    summary_tab_message_btn: 'Summary Report',
    summary_tab_subtitle: 'Congratulations!',
    summary_tab_signature: 'Best of luck to you and your business,',
    summary_tab_success_text:
        'To smoothly transition into your work, take a look at our video tutorials. \n Also, look for the Help button, found wherever you are in Priority, to find more relevant information.',
    summary_tab_text:
        'The details you recorded are updated in Priority, and you can see them in the summary report, too.',
    summary_tab_success_btn: 'Next',
    summary_tab_list_title: 'There are some details yet to be filled out',
    error_required: 'This is required field',
    error_email: "Use English letters only, and don't forget the @.",
    error_website: 'Please use English letters only.',
    error_phone: 'Please use numbers only.',

    save_data_warn: 'Exit without saving your changes?',
    save_data_yes: 'Yes',
    save_data_no: 'No',
    next_label: 'Next',
    quiz_next_label: 'Next',
    quiz_prev_label: 'Back',
    yes_label: 'Yes',
    no_label: 'No',
    step_ledger: 'General Ledger',
    final_step_title: 'Done',
    step_sales: 'Sales',
    step_inventory: 'Inventory',
    step_purchase: 'Purchase',
    quiz_loader_title: 'Working on it...',
    quiz_loader_text: 'This may take a few moments.',
    dropzone_backdrop_text: 'Drop your file anywhere on the screen',
    general_error_title: 'Something went wrong :(',
    general_error_btn_label: 'Try Again',
    connection_error: 'Please check your internet connection and try again.',
    updates_error:
        'There was a problem updating your settings. \n Please try again. \n If this problem persists, please contact our customer service.',
    complete_label: 'Done',
    message_confirm: 'OK',
    message_cancel: 'Cancel'
};

const he = {
    onboarding_tabs_title: 'צעדים ראשונים',
    onboarding_continue_title: 'להמשיך את התאמת המערכת?',
    onboarding_continue_msg:
        'עדיין לא סיימנו להתאים את המערכת לצרכים שלך.\n' + 'שנמשיך לעשות זאת עכשיו?',
    onboarding_continue_action_primary: 'כן',

    welcome_title: 'ברוכים הבאים ל-Priority',
    welcome_text:
        'ברכות על ההחלטה לקחת את העסק שלך לשלב הבא.\n' +
        'בדקות הקרובות נשאל אותך כמה שאלות, ונרשום כמה פרטים, כדי להתאים את המערכת לצרכים המדויקים של העסק שלך',
    welcome_skip_label: 'לסגור  ולא להציג שוב',
    skip_warning: 'באמת? לא להמשיך את התאמת המערכת לצרכים שלך?',
    welcome_action_secondary: 'בפעם הבאה',
    welcome_action_primary: 'נתחיל',
    skip_btn_label_yes: 'כן, לצאת',
    skip_btn_label_no: 'לא, אני רוצה להמשיך',

    general_info_tab_title: 'סביבת עבודה',
    general_info_tab_subtitle:
        'עכשיו נתאים את המערכת לתהליכי העבודה של העסק שלך.\n' +
        'נעבור על כמה נושאים, ולפי התשובות שלך נכין את סביבת העבודה שלך.',
    general_info_tab_list_title:
        'אם בעתיד השימוש במערכת ישתנה או יתרחב, אפשר לערוך את השינויים בכל רגע בקלות.',

    general_info_tab_start: 'נתחיל',
    general_info_tab_success_title: 'סביבת העבודה שלך מוכנה!',
    general_info_tab_success_text:
        'בסיכום אפשר לראות דו"ח עם הפרטים שעידכנו במערכת, בנוסף לטיפים להתחלת עבודה.',
    general_info_tab_success_btn: 'הבא',

    workspace_dialog_title: 'נתחיל עכשיו להתאים את המערכת שלך.',
    workspace_dialog_btn_ok: 'אישור',
    workspace_dialog_btn_back: 'חזרה',

    company_tab_title: 'פרטי החברה',
    company_tab_subtitle:
        'כאן נגדיר את הפרטים הבסיסיים של החברה שלך.\n המידע הזה יופיע על מסמכים והדפסות.',
    company_name_label: 'שם החברה',
    company_name_placeholder: 'לרשום כאן את השם...',
    tax_id_label: 'מספר תיק במע"מ',
    tax_id_placeholder: 'לרשום כאן את המספר...',
    company_number: 'מספר עוסק מורשה',
    company_number_placeholder: 'לרשום כאן את המספר...',
    logo_label: 'לוגו',
    logo_placeholder: 'כאן אפשר להוסיף את קובץ הלוגו',
    street_label: 'כתובת',
    street_placeholder: 'לרשום כאן רחוב ומספר בית…',
    city_label: 'עיר',
    city_placeholder: 'לרשום כאן את שם הישוב...',
    state_label: 'מדינה',
    state_placeholder: 'לבחור כאן את המדינה...',
    country_label: 'ארץ',
    country_placeholder: 'לבחור כאן את הארץ...',
    zipcode_label: 'מיקוד',
    zipcode_placeholder: 'לרשום כאן את המיקוד...',
    email_label: 'אימייל',
    email_placeholder: 'your@email.com',
    website_label: 'אתר אינטרנט',
    website_placeholder: 'https://www.yourwebsite.com',
    phone_label: 'מספר טלפון',
    phone_placeholder: '051-234-5678',
    company_tab_submit: 'שמירה',
    company_readonly_subtitle: 'הגדרנו את פרטי החברה שלך כפי שרשמת כאן:',
    company_readonly_footer_text: 'אפשר לשנות את פרטי החברה כאן:',
    company_readonly_footer_btn: 'מסך נתוני החברה',

    bank_acc_tab_title: 'חשבון בנק',
    bank_acc_tab_subtitle:
        'כאן נגדיר את חשבון הבנק שלך במערכת.\n' +
        'אפשר להגדיר פרטים נוספים לחשבון, או להוסיף חשבונות נוספים, במסך "חשבונות בנק" בפריוריטי.',

    bank_code_name_label: 'בנק',
    bank_code_name_placeholder: 'לבחור מהרשימה...',
    branch_number_label: 'סניף הבנק',
    branch_number_placeholder: 'לרשום כאן את מספר הסניף...',
    account_number_label: 'מספר החשבון',
    account_number_placeholder: 'לרשום כאן את מספר החשבון...',
    account_name_label: 'שם החשבון',
    account_name_placeholder: 'תיאור חשבון הבנק שלך...',
    account_currency_label: 'מטבע החשבון',
    account_currency_placeholder: '"לבחור מהרשימה..."',
    gl_account_label: 'חשבון בהנהלת חשבונות',
    gl_account_placeholder: 'לבחור כאן את החשבון בהנה"ח...',
    send_invoices_label: 'להגדיר חתימה דיגיטלית מאובטחת למסמכים?',
    send_invoices_desc: 'החתימה תופיע על חשבוניות, קבלות וכדומה.',
    send_invoices_help:
        'בחרו ב"כן" כדי להגדיר עכשיו חתימה דיגיטלית מאובטחת על מסמכי PDF המופקים בפריוריטי.\n' +
        'החתימה שנגדיר כאן היא חתימה מאובטחת מבית פריוריטי.\n' +
        '\n' +
        'אם מעוניינים בחתימה דיגיטלית של ספק חיצוני, יש לרכוש תעודת חתימה להשתמש בתוכנית "הגדרת חתימה על מסמכי PDF" כדי להגדיר אותה במערכת.',
    send_invoices_yes: 'כן',
    send_invoices_no: 'לא כרגע',
    bank_tab_submit: 'שמירה',
    bank_acc_tab_success: 'שמרנו את פרטי חשבון הבנק שלך בהצלחה.',
    bank_acc_readonly_subtitle: 'הגדרנו את פרטי חשבון הבנק שלך כפי שרשמת כאן:',
    bank_account_changes_msg: 'אפשר לשנות ולהוסיף פרטים לחשבון זה, או לרשום עוד חשבונות בנק, כאן:',
    bank_account_multi_accounts_msg: 'כל חשבונות הבנק שלך מופיעים כאן:',
    bank_acc_btn: 'מסך חשבונות בנק',

    summary_tab_title: 'סיכום',
    summary_tab_subtext:
        'The details you recorded are updated in Priority, and you can see them in the summary report, too.',
    summary_tab_btn: 'סיום',
    summary_tab_message: 'Want to see what you did?',
    summary_tab_message_btn: 'דו"ח סיכום',
    summary_tab_signature: 'בברכת הצלחה ועסקים פוריים,',
    summary_tab_subtitle: 'Congratulations',
    summary_tab_success_text:
        'להתחלת עבודה חלקה, כדאי להכיר את סרטוני ההדרכה. \n בנוסף, בכל מקום במערכת מופיע כפתור עזרה, לחיצה עליו תחשוף אותך למידע רלוונטי.',
    summary_list_title: 'עדיין לא השלמת את כל הפרטים:',
    summary_tab_text: 'כל הפרטים שרשמת מעודכנים במערכת, והם גם מופיעים בדו"ח המסכם.',
    summary_tab_success_btn: 'הבא',
    error_required: 'נא להשלים את השדה. לא נוכל להמשיך בלעדיו.',
    error_email: 'אפשר להשתמש באותיות באנגלית בלבד, ולא לשכוח את הכרוכית @.',
    error_website: 'אפשר להשתמש באותיות באנגלית בלבד',
    error_phone: 'אפשר לרשום כאן רק מספרים, בלי תווים אחרים',

    save_data_warn: 'לצאת בלי לשמור את השינויים?',
    save_data_yes: 'כן',
    save_data_no: 'לא',
    next_label: 'הבא',
    quiz_next_label: 'הבא',
    quiz_prev_label: 'חזרה',
    yes_label: 'כן',
    no_label: 'לא',

    step_ledger: 'הנהלת חשבונות',
    step_sales: 'מכירות',
    step_inventory: 'מלאי',
    step_purchase: 'רכש',
    final_step_title: 'סיום',
    quiz_loader_title: 'מכינים את המערכת שלך...',
    quiz_loader_text: 'זה יכול לקחת כמה רגעים.',
    dropzone_backdrop_text: 'להניח את הקובץ כאן, נשמור אותו במקום המתאים.',
    general_error_title: 'Something went wrong :(',
    general_error_btn_label: 'לנסות שוב',
    connection_error: 'נתקלנו בבעיית תקשורת. כדאי לבדוק את החיבור לאינטרנט ולנסות שוב.',
    updates_error:
        'הייתה בעיה בשמירת ההגדרות.\n' +
        'כדאי לנסות שוב.\n' +
        'אם הבעיה ממשיכה, כדאי ליצור קשר עם התמיכה שלנו.',
    complete_label: 'אישור',
    message_confirm: 'אישור',
    message_cancel: 'ביטול'
};

const fallback = {en, he};

export const mapping = {
    1: 'bank_acc_tab_title',
    2: 'bank_acc_tab_subtitle',
    3: 'bank_code_name_label',
    4: 'bank_code_name_placeholder',
    5: 'branch_number_label',
    6: 'branch_number_placeholder',
    7: 'account_number_label',
    8: 'account_number_placeholder',
    9: 'account_name_label',
    10: 'account_name_placeholder',
    11: 'account_currency_label',
    12: 'account_currency_placeholder',
    13: 'send_invoices_label',
    14: 'send_invoices_yes',
    15: 'send_invoices_no',
    16: 'bank_tab_submit',
    17: 'bank_acc_tab_success',
    18: 'bank_acc_readonly_subtitle',
    19: 'bank_account_changes_msg',
    20: 'bank_acc_btn',
    21: 'bank_account_multi_accounts_msg',
    22: 'company_tab_title',
    23: 'company_tab_subtitle',
    24: 'company_name_label',
    25: 'company_name_placeholder',
    26: 'tax_id_label',
    27: 'tax_id_placeholder',
    28: 'logo_label',
    29: 'logo_placeholder',
    30: 'street_label',
    31: 'street_placeholder',
    32: 'city_label',
    33: 'city_placeholder',
    34: 'state_label',
    35: 'state_placeholder',
    36: 'country_label',
    37: 'country_placeholder',
    38: 'zipcode_label',
    39: 'zipcode_placeholder',
    40: 'email_label',
    41: 'email_placeholder',
    42: 'website_label',
    43: 'website_placeholder',
    44: 'phone_label',
    45: 'phone_placeholder',
    46: 'company_tab_submit',
    47: 'company_readonly_subtitle',
    48: 'company_readonly_footer_text',
    49: 'company_readonly_footer_btn',
    50: 'error_email',
    52: 'error_website',
    53: 'error_phone',
    54: 'send_invoices_desc',
    55: 'welcome_title',
    56: 'welcome_text',
    57: 'welcome_action_primary',
    58: 'welcome_action_secondary',
    59: 'welcome_skip_label',
    60: 'skip_warning',
    61: 'skip_btn_label_yes',
    62: 'skip_btn_label_no',
    63: 'onboarding_continue_title',
    64: 'onboarding_continue_msg',
    65: 'onboarding_continue_action_primary',
    66: 'save_data_warn',
    67: 'save_data_yes',
    68: 'save_data_no',
    69: 'complete_label',
    70: 'general_info_tab_title',
    71: 'general_info_tab_subtitle',
    72: 'general_info_tab_list_title',
    73: 'general_info_tab_start',
    74: 'workspace_dialog_title',
    75: 'workspace_dialog_btn_ok',
    76: 'workspace_dialog_btn_back',
    77: 'quiz_loader_title',
    78: 'quiz_loader_text',
    79: 'connection_error',
    80: 'general_error_btn_label',
    81: 'updates_error',
    83: 'company_number',
    84: 'company_number_placeholder',
    85: 'send_invoices_help',
    86: 'gl_account_label',
    88: 'summary_tab_title',
    89: 'onboarding_tabs_title',
    90: 'general_info_tab_success_title',
    91: 'general_info_tab_success_text',
    92: 'quiz_next_label',
    93: 'quiz_prev_label',
    94: 'summary_tab_text',
    95: 'summary_list_title',
    96: 'summary_tab_message_btn',
    97: 'summary_tab_btn',
    98: 'dropzone_backdrop_text',
    99: 'final_step_title',
    100: 'error_required',
    101: 'gl_account_placeholder',
    102: 'summary_tab_success_text',
    103: 'summary_tab_signature',
    104: 'general_error_title',
    105: 'summary_tab_subtext',
    106: 'summary_tab_subtitle',
    107: 'summary_tab_message',
    108: 'bank_acc_tab_success'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallback);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
